module.exports = __webpack_public_path__ + "static/media/hot_wwgk.00e4e923.png";